@if (inputCounter === 0) {
  <div>You don't have Items of {{ category }}</div>
} @else {
  @if (loading) {
    <div><span nz-icon nzType="loading" nzTheme="outline"></span> Loading...</div>
  }
  @if (!loading) {
    <div class="dd-grid dd-header sticky-dd">
      <div>Vendor Name</div>
      <div nz-tooltip="Allotments">A</div>
      <div nz-tooltip="Schedules">S</div>
      <div nz-tooltip="Rate Levels">RL</div>
    </div>
    @for (item of sortedItems; track item) {
      <div class="dd-grid">
        <div
          class="vendor-nav"
          nz-tooltip="Click to Edit Vendor Details"
          [routerLink]="['/vendor', systemCategory.toLowerCase(), 'edit', item.vendor.vendorId]"
        >
          {{ item.name }}
        </div>

        <div>
          @if (item.vendorFlags.noAllotments) {
            <span
              nz-icon
              nz-tooltip="Click here to Manage Allotments"
              (click)="edit(item, 'allotments')"
              class="icon-red"
              nzType="close"
              nzTheme="outline"
            ></span>
          }
          @if (!item.vendorFlags.noAllotments) {
            <span nz-icon class="icon-green" nzType="check" nzTheme="outline"></span>
          }
        </div>

        <div>
          @if (item.vendorFlags.noSchedules) {
            <span
              nz-icon
              nz-tooltip="Click here to Manage Schedules"
              (click)="edit(item, 'schedules')"
              class="icon-red"
              nzType="close"
              nzTheme="outline"
            ></span>
          }
          @if (!item.vendorFlags.noSchedules) {
            <span nz-icon class="icon-green" nzType="check" nzTheme="outline"></span>
          }
        </div>

        <div>
          @if (item.vendorFlags.noRateLevels) {
            <span
              nz-icon
              nz-tooltip="Click here to Manage Rate Levels"
              (click)="edit(item, 'rate-levels')"
              class="icon-red"
              nzType="close"
              nzTheme="outline"
            ></span>
          }
          @if (!item.vendorFlags.noRateLevels) {
            <span nz-icon class="icon-green" nzType="check" nzTheme="outline"></span>
          }
        </div>
      </div>
    }
  }
}
